module.exports = __webpack_public_path__ + "img/2021-wemlo-TILES-D_FNL_3-01.57b4513d.png";